export default function ({ app }) {
  app.$cookies.removeAll()
  app.$cookies.remove('token', { path: '/v2' })
}
